<template>
  <div
    class="h-16 flex items-center m-1 bg-white rounded-md px-3 py-1 gap-3 shadow active:bg-gray-100"
    @click.stop.prevent="onClick()"
  >
    <i :class="icon" class="text-lg text-gray-700"></i>
    <div class="h-full w-full overflow-hidden *:leading-tight flex flex-col justify-center">
      <div class="text-base text-gray-900 font-bold">
        <span v-for="part of row.mainParts" :class="part.match ? 'text-cyan-700 bg-cyan-100 rounded' : ''">{{
          part.text
        }}</span>
      </div>
      <div class="text-xs text-gray-700">
        <span v-if="!row.value.isProgrammed">Not programmed anywhere</span>
        <span v-else-if="row.value.isProgrammed && !row.value.isUserAuthorizedToView"
          >Programmed to a property you don't have access to</span
        >
        <span v-else>
          {{ row.value.programmedContext?.property?.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Prediction } from '@/components/forms/typeahead/type-ahead';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { DeviceSearchRow, ProgrammedDeviceContext } from 'common';
import { computed } from 'vue';

const props = defineProps<{
  row: Prediction<DeviceSearchRow>;
}>();

const icon = computed(() => {
  return props.row.value.deviceType?.iconName || 'icon-transceiver';
});

const emit = defineEmits<{
  (e: 'resultClicked', val: { context?: ProgrammedDeviceContext; deviceId?: number }): void;
}>();

function onClick() {
  const r = props.row.value;
  if (r.isProgrammed && r.isUserAuthorizedToView && r.programmedContext) {
    Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
    emit('resultClicked', { context: r.programmedContext, deviceId: props.row.value._id });
  }
}
</script>

<style scoped></style>
